/* global window */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/function';
import { GALLERY_NAVIGATION_TILE_NAME } from 'Constants/items';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import withLocalStorage from 'HOCs/withLocalStorage/withLocalStorage';

const SPIN_CAR_TT_SHOWN = 'spin-car-tt-shown';
const TT_DURATION = 5000;

export function ImageTile({
    name,
    url,
    onClick = noop,
    css,
    intl,
    id,
    localStorage
}) {
    const onTileClick = evt => {
        evt.stopPropagation();
        onClick(id);
    };

    const spinCarTTShown = localStorage.getItem(SPIN_CAR_TT_SHOWN);
    const [showToolTip, setShowToolTip] = useState(id === GALLERY_NAVIGATION_TILE_NAME.SPIN_CAR && !spinCarTTShown && typeof window !== 'undefined');

    useEffect(() => {
        if (showToolTip) {
            setTimeout(() => {
                localStorage.setItem(SPIN_CAR_TT_SHOWN, 1);
                setShowToolTip(false);
            }, TT_DURATION);
        }
    }, []);

    return (
        <div
            className={ classNames(css.inspectionImagesTiles__tile, {
                [css.tooltip]: showToolTip
            }) }
            data-tooltip={ intl.formatMessage({ id: 'spinCarToolTip' }) }
            key={ id }
            onClick={ onTileClick } // eslint-disable-line react/jsx-no-bind
            data-aut-id={ `tile-${id}` }
        >
            <div className={ css.imgWrapper }>
                <img className={ css.inspectionImagesTiles__tile__image } src={ url } alt={ name } />
            </div>
            <div className={ css.inspectionImagesTiles__tile__title } >
                {name}
            </div>
        </div>
    );
}

ImageTile.propTypes = {
    css: PropTypes.object,
    name: PropTypes.string,
    url: PropTypes.string,
    id: PropTypes.string,
    onClick: PropTypes.func,
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired
    }).isRequired,
    localStorage: PropTypes.shape({
        setItem: PropTypes.func,
        getItem: PropTypes.func
    }).isRequired
};

export default compose(
    withLocalStorage,
    injectIntl,
    React.memo
)(ImageTile);
